/**
 * O código que o vendedor e o cliente veem: os 6 últimos caracteres do id do
 * pedido, em maiúsculas ("A1B2C3", sem o `#`). Igual ao
 * `domain/utils/orderCode.ts` dos dois aplicativos e ao `utils/orderCode.ts`
 * do backend: o painel mostra o mesmo código do push e da lista do vendedor.
 * Nenhum pedido tem número próprio gravado: o código sai sempre do id.
 */
export function orderCode(orderId: string): string {
  return (orderId ?? "").slice(-6).toUpperCase();
}
